/**
 * Phase 3 — Lifestyle blocks, FAQ per listing and auto-comparison config.
 * Persisted in `listings` columns: `lifestyle`, `faqs`, `comparison_config` (jsonb).
 */

export interface LifestyleBlock {
  icon: string;   // emoji or short symbol
  title: string;
  description: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface ComparisonExtra {
  label: string;   // e.g. "Preço médio do bairro"
  value: string;   // e.g. "R$ 3.500.000"
}

export interface ComparisonConfig {
  /** When true, the auto-generated comparison table appears on the listing page */
  enabled?: boolean;
  /** Custom highlight shown ABOVE this listing in the comparison (e.g. "Melhor custo-benefício") */
  highlight?: string;
  /** Extra rows appended to the comparison table (custom criteria) */
  extras?: ComparisonExtra[];
}

export const EMPTY_COMPARISON_CONFIG: ComparisonConfig = {
  enabled: false,
  highlight: "",
  extras: [],
};

export const LIFESTYLE_PRESETS: LifestyleBlock[] = [
  { icon: "🌅", title: "Amanheça com vista", description: "Comece o dia com uma paisagem única direto da varanda." },
  { icon: "🏃", title: "Vida ativa ao ar livre", description: "Ciclovia, parques e orla a poucos passos." },
  { icon: "🍽️", title: "Gastronomia à mão", description: "Restaurantes premiados e cafés no seu bairro." },
  { icon: "🛍️", title: "Compras e lazer", description: "Shoppings, mercados e serviços em raio curto." },
  { icon: "🎭", title: "Cultura e arte", description: "Teatros, cinemas e centros culturais próximos." },
  { icon: "🚇", title: "Conectado à cidade", description: "Metrô, BRT e vias expressas a minutos de casa." },
];
